import { Col, Flex, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteSmsTemplateById,
  fetchSmsTemplateById,
} from "../../../lib/api/resources/sms";
import { SmsTemplateDetailCard } from "./components/SmsTemplateDetailCard";

export const SmsTemplateDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const { data, isLoading } = useQuery({
    queryKey: ["smsTemplate", id],
    queryFn: () => fetchSmsTemplateById(id),
  });

  const deleteSmsTemplateMutation = useMutation({
    mutationFn: () => deleteSmsTemplateById(id),
    onSuccess: () => {
      navigate(`/sms-templates`);
      message.success("SMS Template succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de SMS Template",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <SmsTemplateDetailCard
              deleteMutation={deleteSmsTemplateMutation}
              smsTemplate={data}
              isLoading={isLoading}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
